import React, {Fragment, useCallback, useEffect, useState} from "react";
import {
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {Controller, useFormContext} from "react-hook-form";
import {
  DialogTitle,
  EnhancedTableHead,
  FormControlLabelRadio,
  Label,
  SubTitle,
} from "../index";
import {
  axle,
  axleWeight,
  changeVehicleWeight,
  damas,
  damasWeight,
  labo,
  laboWeight,
  motorcycle,
  motorcycleWeight,
} from "../../lib";

import CloseIcon from "@mui/icons-material/Close";
import {vehicleDimension} from "./vehicleDimension";

const showFixedListCount = 4;

const useStyles = makeStyles(() => ({
  vehicleDimensionMark: {
    width: 16,
    height: 16,
    borderRadius: "50%",
    border: "1px solid gray",
    textAlign: "center",
    marginTop: 2,
    marginLeft: 10,
    fontSize: 10,
    cursor: "pointer",
  },
  row: {
    textAlign: "center",
  },
  vehicleTypeContainer: {
    marginTop: 6,
    marginLeft: 10,

    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#4a4a4a",
    },
    "& .MuiTypography-body1": {
      marginLeft: 4,
      fontWeight: 500,
      letterSpacing: -0.42,
    },
  },
  radioLegend: {
    fontSize: 11,
  },
  radioButton: {
    marginRight: 22,
  },
  select: {
    width: 96,
    marginLeft: -6,
  },
  optionBackDoorOpen: {
    marginTop: -3,
    marginLeft: -10,
  },
  firstRow: {
    marginTop: 14,
  },
  vehicleInfoitem: {
    marginTop: 6,
  },
  buttonClose: {
    position: "absolute",
    top: 22,
    right: 21,
    marginRight: 8,
  },
  dialogContent: {
    paddingBottom: 24,
  },
  table: {
    textAlign: "center",
    padding: 0,
    backgroundColor: "#ffffff",
    borderRadius: 3.8,
    border: "solid 1px #ebedf8",
  },
  inTable: {
    padding: "10px 32px 32px 32px",
  },
  dialog: {
    textAlign: "center",
  },
  subTitle: {
    marginLeft: 32,
    marginTop: 16,
    fontSize: 12,
    fontWeight: "bold",
  },
  subTitleMessage: {
    fontFamily: "NotoSansKR",
    marginLeft: 32,
    marginTop: 16,
    fontSize: 14,
    fontWeight: "bold",
  },
  subTitleInfo: {
    fontFamily: "NotoSansKR",
    marginRight: 32,
    marginTop: 16,
    fontSize: 11,
    fontWeight: "bold",
    color: "rgba(104, 104, 104, 0.6)",
  },
  subTitleInfo2: {
    fontFamily: "NotoSansKR",
    marginRight: 32,
    fontSize: 11,
    fontWeight: "bold",
    color: "rgba(104, 104, 104, 0.6)",
  },
}));

export const VehicleDimension = () => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const headCells = [
    {label: "차량톤수"},
    {label: "폭 (mm)"},
    {label: "길이 (mm)"},
    {label: "높이 (mm)"},
    {label: "최대 적재 중량"},
    {label: "최대 적재 파렛*"},
  ];
  return (
    <>
      <div className={classes.vehicleDimensionMark} onClick={handleClickOpen}>
        ?
      </div>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="confirmation-dialog-title"
        className={classes.dialog}
      >
        <IconButton
          size="small"
          onClick={handleClose}
          className={classes.buttonClose}
        >
          <CloseIcon/>
        </IconButton>
        <DialogTitle>차량 제원</DialogTitle>
        <Grid container direction={"row"} justifyContent={"space-between"}>
          <Grid className={classes.subTitleMessage}>톤수별 적재함 사이즈</Grid>
          <Grid className={classes.subTitleInfo}>
            *1100 x 1100 파렛트 규격 기준
          </Grid>
        </Grid>
        <Grid container direction={"row"} justifyContent={"flex-end"}>
          <Grid className={classes.subTitleInfo2}>
            *높이는 탑차,윙바디 기준
          </Grid>
        </Grid>
        <div className={classes.inTable}>
          <Table className={classes.table}>
            <EnhancedTableHead classes={classes} headCells={headCells}/>
            <TableBody>
              {vehicleDimension().map((a: any, i: number) => (
                <TableRow key={i}>
                  <TableCell className={classes.row}>{a.ton}톤</TableCell>
                  <TableCell className={classes.row}>{a.width}</TableCell>
                  <TableCell className={classes.row}>{a.length}</TableCell>
                  <TableCell className={classes.row}>{a.height}</TableCell>
                  <TableCell className={classes.row}>{a.maxWeight}톤</TableCell>
                  <TableCell className={classes.row}>{a.maxPt}개</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Dialog>
    </>
  );
};

const VehicleTypeRadioGroup = (props: any) => {
  const classes = useStyles();
  const {
    name,
    setDisableVehicleTypeList,
    selectedVehicleTypeInList,
    optionList,
  } = props;
  const {control, setValue} = useFormContext();
  const fixedVehicleTypes = optionList.slice(0, showFixedListCount);
  const [radioValueVehicleType, setRadioValueVehicleType] = useState(
    optionList[0]
  );

  const updateVehicleType = useCallback(
    (vehicleType: string) => {
      setRadioValueVehicleType(vehicleType);
      setValue(name, vehicleType);
    },
    [setRadioValueVehicleType, setValue, name]
  );

  useEffect(() => {
    const firstVehicleType = optionList[0];
    updateVehicleType(firstVehicleType);
  }, [optionList, updateVehicleType]);

  // useEffect(() => {
  //   console.log(1);
  //   window.gtag("event", `운송주문-차량 타입선택`, {
  //     user_id: localStorage.getItem("customerName") || "none",
  //   });
  // }, [radioValueVehicleType]);

  return (
    <>
      <div>
        <Grid container>
          <Grid item>
            <Label required={true}>{"차량종류"}</Label>
          </Grid>
          <Grid item>
            <VehicleDimension/>
          </Grid>
        </Grid>
      </div>
      <Controller // control 로 감싸줘야 form 에서 데이터를 가져감
        control={control}
        name={name}
        render={({field}) => (
          <FormControl
            component="fieldset"
            className={classes.vehicleTypeContainer}
          >
            <RadioGroup
              {...field}
              value={radioValueVehicleType} // id 값이 1부터 시작하기 때문에
              onChange={(e: any) => {
                console.log(`운송주문-차량 타입 변경`);
                window.gtag("event", `운송주문-차량 타입 변경`, {
                  user_id: localStorage.getItem("customerName") || "none",
                });
                field.onChange(e);
                const val = e.target.value;
                setRadioValueVehicleType(val);
                if (val === "오토바이") setValue("totalWeight", "0");
                if (val === "기타") {
                  setDisableVehicleTypeList(false);
                  setValue(name, selectedVehicleTypeInList);
                  setValue("vehicleType", selectedVehicleTypeInList);
                  return;
                }
                setDisableVehicleTypeList(true);
                setValue(name, val);
                setValue("vehicleType", val);
              }}
              row
            >
              {fixedVehicleTypes.map((v: string, i: number) => (
                <FormControlLabelRadio key={i} value={v} label={v}/>
              ))}
              <FormControlLabel
                key={999}
                value={"기타"} // The DOM API casts this to a string.
                control={<Radio color={"default"}/>}
                label={"기타"}
              />
            </RadioGroup>
          </FormControl>
        )}
      />
    </>
  );
};

const VehicleTypeSelectList = (props: any) => {
  const classes = useStyles();
  const {
    name,
    disableVehicleTypeList,
    selectedVehicleTypeInList,
    setSelectedVehicleTypeInList,
    optionList,
  } = props;
  const {control} = useFormContext();
  const {setValue} = useFormContext();

  return (
    <Controller // control 로 감싸줘야 form 에서 데이터를 가져감
      control={control}
      name={name}
      render={({field}) => (
        <FormControl
          disabled={disableVehicleTypeList}
          className={classes.select}
        >
          <Select
            {...field}
            value={selectedVehicleTypeInList}
            variant={"standard"}
            onChange={(e: any) => {
              console.log(`운송주문-차량 타입 변경(in select box)`);
              window.gtag("event", `운송주문-차량 타입 변경`, {
                user_id: localStorage.getItem("customerName") || "none",
              });

              if (e.target.value === "오토바이") {
                setValue("totalWeight", "0");
                setValue("packagingType", "box");
              }
              field.onChange(e);
              setValue("vehicleType", e.target.value);
              setSelectedVehicleTypeInList(e.target.value);
            }}
          >
            {optionList.slice(showFixedListCount).map((v: any, i: number) => (
              <MenuItem key={i} value={v}>
                {v}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
};

const VehicleWeightRadioGroup = (props: any) => {
  const classes = useStyles();
  const {name, selectedVehicleWeightInList, optionList} = props;

  const [fixedVehicleWeights, setFixedVehicleWeights] = useState(optionList);
  const [radioValueVehicleWeight, setRadioValueVehicleWeight] =
    useState<string>(optionList[0]);

  const {control, setValue, watch} = useFormContext();

  const updateVehicleWeight = useCallback(
    (vehicleWeight: string) => {
      setRadioValueVehicleWeight(vehicleWeight);
      setValue(name, vehicleWeight);
      setValue("vehicleWeight", vehicleWeight);
    },
    [setRadioValueVehicleWeight, setValue, name]
  );

  useEffect(() => {
    if (motorcycle.includes(watch("vehicleType"))) {
      setFixedVehicleWeights([motorcycleWeight]);
    } else if (damas.includes(watch("vehicleType"))) {
      setFixedVehicleWeights([damasWeight]);
    } else if (labo.includes(watch("vehicleType"))) {
      setFixedVehicleWeights([laboWeight]);
    } else if (axle.includes(watch("vehicleType"))) {
      //축 차량 요청시
      setFixedVehicleWeights([axleWeight]);
    } else {
      setFixedVehicleWeights(optionList);
    }
  }, [watch("vehicleType"), optionList]);

  useEffect(() => {
    updateVehicleWeight(fixedVehicleWeights[0].toString());
  }, [fixedVehicleWeights, watch("vehicleType")]);

  return (
    <>
      <div>
        <Label required={true}>{"차량중량"}</Label>
      </div>
      <Controller // control 로 감싸줘야 form 에서 데이터를 가져감
        control={control}
        name={name}
        render={({field}) => (
          <FormControl
            component="fieldset"
            className={classes.vehicleTypeContainer}
          >
            <RadioGroup
              {...field}
              value={radioValueVehicleWeight.toString()} // id 값이 1부터 시작하기 때문에
              onChange={(e: any) => {
                field.onChange(e);
                window.gtag("event", `운송주문-차량 중량 변경`, {
                  user_id: localStorage.getItem("customerName") || "none",
                });
                const val = e.target.value;
                //setDisableVehicleWeightList(true);
                if (val === "기타") {
                  setRadioValueVehicleWeight(val);
                  setValue(name, selectedVehicleWeightInList);
                  setValue("vehicleWeight", selectedVehicleWeightInList);
                  // setDisableVehicleWeightList(false);
                  return;
                }

                updateVehicleWeight(val);
                // setDisableVehicleWeightList(true);
              }}
              row
            >
              {watch("vehicleType") === motorcycle &&
                fixedVehicleWeights.map((v: number, i: number) => (
                  <FormControlLabelRadio
                    key={i}
                    value={motorcycleWeight.toString()}
                    label={changeVehicleWeight(
                      watch("vehicleType"),
                      v.toString()
                    )}
                  />
                ))}
              {watch("vehicleType") !== motorcycle &&
                fixedVehicleWeights.map((v: number, i: number) => (
                  <FormControlLabelRadio
                    key={i}
                    value={v.toString()}
                    label={changeVehicleWeight(
                      watch("vehicleType"),
                      v.toString()
                    )}
                  />
                ))}
              {/*<FormControlLabel*/}
              {/*  key={999}*/}
              {/*  value={'기타'}  // The DOM API casts this to a string.*/}
              {/*  control={<Radio/>}*/}
              {/*  label={'기타'}*/}
              {/*  disabled={fixedVehicleWeights.length < 4}*/}
              {/*/>*/}
            </RadioGroup>
          </FormControl>
        )}
      />
    </>
  );
};


const OptionBackDoorOpen = () => {
  const classes = useStyles();
  const {control, setValue} = useFormContext();
  const name = "optionBackDoorOpen";

  return (
    <Controller // control 로 감싸줘야 form 에서 데이터를 가져감
      control={control}
      name={name}
      render={({field}) => (
        <FormControlLabel
          className={classes.optionBackDoorOpen}
          control={
            <Checkbox
              {...field}
              value={field.value} // The DOM API casts this to a string.
              onChange={(e: any) => {
                const val = e.target.checked;
                field.onChange(e);
                setValue(name, val); // DOM API 가 string 으로 컨버팅 하기 때문에 값을 다시 넣어준다.
              }}
              color="primary"
            />
          }
          label="뒷문개방"
        />
      )}
    />
  );
};

const OptionMixedLoading = () => {
  const {register} = useFormContext();
  const name = "optionMixedLoading";
  const {watch, setValue} = useFormContext();

  return (
    <FormControlLabel
      control={
        <Checkbox
          {...register(name)}
          checked={watch("optionMixedLoading") === true}
          onChange={(e: any) => {
            const val = e.target.checked;
            setValue("optionMixedLoading", val);
          }}
          color="primary"
        />
      }
      label="혼적가능"
    />
  );
};

const VehicleType = (props: any) => {
  const {
    configVehicleTypes,
    selectedVehicleTypeInList,
    setSelectedVehicleTypeInList,
  } = props;
  const name = "vehicleType";
  const [disableVehicleTypeList, setDisableVehicleTypeList] =
    useState<boolean>(true);
  return (
    <Fragment>
      <Grid container direction={"column"}>
        <Grid item>
          <VehicleTypeRadioGroup
            name={name}
            optionList={configVehicleTypes}
            setDisableVehicleTypeList={setDisableVehicleTypeList}
            selectedVehicleTypeInList={selectedVehicleTypeInList}
          />

          <VehicleTypeSelectList
            name={name}
            optionList={configVehicleTypes}
            disableVehicleTypeList={disableVehicleTypeList}
            selectedVehicleTypeInList={selectedVehicleTypeInList}
            setSelectedVehicleTypeInList={setSelectedVehicleTypeInList}
          />
        </Grid>
        <Grid item>
          <OptionBackDoorOpen/>
        </Grid>
      </Grid>
    </Fragment>
  );
};

const VehicleWeight = (props: any) => {
  const {configVehicleWeight, selectedVehicleWeightInList} = props;
  const name = "vehicleWeight";
  // const [disableVehicleWeightList, setDisableVehicleWeightList] = useState<boolean>(true);

  return (
    <Fragment>
      <VehicleWeightRadioGroup
        name={name}
        optionList={configVehicleWeight}
        // setDisableVehicleWeightList={setDisableVehicleWeightList}
        selectedVehicleWeightInList={selectedVehicleWeightInList}
      />
      {/*<VehicleWeightSelectList*/}
      {/*  name={name}*/}
      {/*  optionList={configVehicleWeight}*/}
      {/*  disableVehicleWeightList={disableVehicleWeightList}*/}
      {/*  setDisableVehicleWeightList={setDisableVehicleWeightList}*/}
      {/*  selectedVehicleWeightInList={selectedVehicleWeightInList}*/}
      {/*  setSelectedVehicleWeightInList={setSelectedVehicleWeightInList}*/}
      {/*/>*/}
    </Fragment>
  );
};

const Item = (props: any) => {
  const {item, packagingType, configIsInputTotalLength} = props;

  const name = "item";
  const {register, setValue} = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  const [placeholderText, setPlaceholderText] = useState<string>("");

  useEffect(() => {
    setValue(name, item);
  }, [setValue, item]);

  useEffect(() => {
    if (packagingType === "pt")
      setPlaceholderText("ex) 제품명/5파렛 (1200*1000)");
    if (packagingType === "box")
      setPlaceholderText("ex) 제품명/10박스 (40 * 60 * 50)");
    if (packagingType === "etc")
      setPlaceholderText("ex) 제품명/(140 * 200 * 150)");
  }, [packagingType]);

  return (
    <TextField
      {...register(name)}
      style={{width: configIsInputTotalLength ? 300 : 380}}
      variant={"standard"}
      defaultValue={item}
      required
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{
        maxLength: 150,
      }}
      onFocus={() => {
        console.log(`운송주문-품목 변경 시작`);
        window.gtag("event", `운송주문-품목 변경 시작`, {
          user_id: localStorage.getItem("customerName") || "none",
        });
      }}
      onBlur={() => {
        console.log(`운송주문-품목 변경 종료`);
        window.gtag("event", `운송주문-품목 변경 종료`, {
          user_id: localStorage.getItem("customerName") || "none",
        });
      }}
      label={"품목 상세"}
      placeholder={placeholderText}
    />
  );
};

const PackagingType = (props: any) => {
  const {packagingType, setPackagingType, config} = props;

  const {control, setValue, watch} = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  const name = "packagingType";

  const handleChange = (event: any, newAlignment: any) => {
    if (newAlignment !== null) {
      setPackagingType(newAlignment);
      setValue("PackagingType", newAlignment);
    }
    if (
      newAlignment !== "box" &&
      newAlignment !== "etc" &&
      watch("loadingType") === "hand"
    ) {
      setValue("loadingType", "forklift");
    }
    if (
      newAlignment !== "box" &&
      newAlignment !== "etc" &&
      watch("unloadingType") === "hand"
    ) {
      setValue("unloadingType", "forklift");
    }
  };

  useEffect(() => {
    setValue(name, packagingType);
  }, [setValue, packagingType]);

  useEffect(() => {
    setPackagingType(config);
  }, [watch("vehicleType"), setPackagingType]);

  return (
    <Controller
      control={control}
      name={name}
      render={({field}) => (
        <>
          <Label required={true}>{"포장방법"}</Label>
          <ToggleButtonGroup
            {...field}
            color={"standard"}
            value={packagingType}
            style={{height: "30px", marginTop: "8px"}}
            exclusive
            onChange={handleChange}
          >
            {watch("vehicleType") !== "오토바이" && (
              <ToggleButton value="pt">파레트</ToggleButton>
            )}
            <ToggleButton value="box">박스</ToggleButton>
            <ToggleButton value="etc">기타</ToggleButton>
          </ToggleButtonGroup>
        </>
      )}
    />
  );
};

const TotalWeight = () => {
  const name = "totalWeight";
  const {register, setValue} = useFormContext();

  const [weight, setWeight] = useState<string>("");

  const freightWeightChange = (e: any) => {
    let weight = e.target.value.replace(/[^0-9.]/g, "");

    if (weight[0] === "0" && weight[1] !== "." && weight.length > 1)
      weight = weight.substring(1); //정수이면서 0이 맨 앞이면 삭제.
    setWeight(weight);
    setValue(name, weight);
  };

  return (
    <TextField
      {...register(name)}
      variant={"standard"}
      style={{
        width: 80,
      }}
      InputLabelProps={{
        shrink: true,
      }}
      label={"총중량 (톤)"}
      inputProps={{
        maxLength: 5,
      }}
      onFocus={() => {
        console.log(`운송주문-품목 중량입력 시작`);
        window.gtag("event", `운송주문-품목 중량입력 시작`, {
          user_id: localStorage.getItem("customerName") || "none",
        });
      }}
      onBlur={() => {
        console.log(`운송주문-품목 중량입력 종료`);
        window.gtag("event", `운송주문-품목 중량입력 종료`, {
          user_id: localStorage.getItem("customerName") || "none",
        });
      }}
      required
      value={weight}
      onChange={freightWeightChange}
      placeholder={"2.5"}
    />
  );
};

const TotalLength = () => {
  const name = "totalLength";
  const {register, setValue} = useFormContext();

  const [length, setLength] = useState<string>("");

  const freightLengthChange = (e: any) => {
    let length = e.target.value.replace(/[^0-9.]/g, "");

    if (length[0] === "0" && length[1] !== "." && length.length > 1)
      length = length.substring(1); //정수이면서 0이 맨 앞이면 삭제.
    setLength(length);
    setValue(name, length);
  };

  return (
    <TextField
      {...register(name)}
      variant={"standard"}
      style={{
        width: 80,
      }}
      InputLabelProps={{
        shrink: true,
      }}
      label={"총길이 (m)"}
      inputProps={{
        maxLength: 5,
      }}
      value={length}
      onChange={freightLengthChange}
      placeholder={"6.5"}
    />
  );
};

const LoadingMethod = (props: {
    packagingType: string;
    item: string;
    isDeparture: boolean;
    config: string;
  }) => {
    const {packagingType, isDeparture, config} = props;
    const labelText = isDeparture ? "상차방법" : "하차방법";
    const [methodType, setMethodType] = useState("forklift");
    const {control, setValue, watch} = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

    useEffect(() => {
      setValue(isDeparture ? "loadingType" : "unloadingType", methodType);
    }, [setValue, methodType, isDeparture]);

    const handleChange = (event: any, newAlignment: any) => {
      if (newAlignment !== null) {
        setMethodType(newAlignment);
        isDeparture
          ? setValue("loadingType", newAlignment)
          : setValue("unloadingType", newAlignment);
      }
    };

    useEffect(() => {
      setMethodType(config);

      if (watch("packagingType") === "pt" && config === "hand") {
        if (isDeparture) setValue("loadingType", "forklift");
        else setValue("unloadingType", "forklift");
        setMethodType("forklift");
      }

      if (watch("packagingType") === "box" && config === "forklift") {
        if (isDeparture) setValue("loadingType", "hand");
        else setValue("unloadingType", "hand");
        setMethodType("hand");
      }

      if (watch("packagingType") === "box" && config === "crane") {
        if (isDeparture) setValue("loadingType", "hand");
        else setValue("unloadingType", "hand");
        setMethodType("hand");
      }

      if (watch("vehicleType") === "오토바이") {
        if (watch("packagingType") === "pt") setValue("packagingType", "box");
        setValue("loadingType", "hand");
        setValue("unloadingType", "hand");
        setMethodType("hand");
      }
    }, [isDeparture, packagingType, watch("vehicleType")]);

    const getToggleButtonGroupList = (vehicleType: string) => {
      if (vehicleType === "오토바이") {
        return [
          <ToggleButton value="hand">수작업</ToggleButton>,
          <ToggleButton value="etc">기타</ToggleButton>
        ]
      }

      // pt 포장이지만 수작업이 있을 수 있고, box 포장이지만 지게차나 크레인으로 들어올리는 경우도 있음
      return [
        <ToggleButton value="forklift">지게차</ToggleButton>,
        <ToggleButton value="hand">수작업</ToggleButton>,
        <ToggleButton value="crane">크레인</ToggleButton>,
        <ToggleButton value="etc">기타</ToggleButton>
      ]
    }

    return (
      <Controller
        control={control}
        name={isDeparture ? "loadingType" : "unloadingType"}
        render={({field}) => (
          <>
            <Label required={true}>{labelText}</Label>
            {}
            <ToggleButtonGroup
              {...field}
              color={"standard"}
              value={methodType}
              style={{height: "30px", marginTop: "8px"}}
              exclusive
              onChange={handleChange}
            >
              {getToggleButtonGroupList(watch("vehicleType"))}
            </ToggleButtonGroup>
          </>
        )}
      />
    );
  }
;

export default function FreightInfo(props: any) {
  const classes = useStyles();
  const {
    configVehicleTypes,
    selectedVehicleTypeInList,
    setSelectedVehicleTypeInList,
    configVehicleWeight,
    selectedVehicleWeightInList,
    setSelectedVehicleWeightInList,
    configItem,
    configIsInputTotalLength,
  } = props;
  const [packagingType, setPackagingType] = useState("pt");
  const {watch} = useFormContext();

  return (
    <Fragment>
      <SubTitle>{"화물 정보"}</SubTitle>
      <Grid container direction="column">
        <Grid item className={classes.firstRow}>
          <VehicleType
            configVehicleTypes={configVehicleTypes}
            selectedVehicleTypeInList={selectedVehicleTypeInList}
            setSelectedVehicleTypeInList={setSelectedVehicleTypeInList}
          />
        </Grid>
        <Grid item className={classes.vehicleInfoitem}>
          <VehicleWeight
            configVehicleWeight={configVehicleWeight}
            selectedVehicleWeightInList={selectedVehicleWeightInList}
            setSelectedVehicleWeightInList={setSelectedVehicleWeightInList}
          />
        </Grid>
        <Grid item className={classes.vehicleInfoitem}>
          <Grid container direction={"column"} spacing={2}>
            <Grid item style={{marginTop: 10}}>
              <PackagingType
                item={configItem}
                packagingType={packagingType}
                setPackagingType={setPackagingType}
                config={watch("packagingType")}
              />
            </Grid>
            <Grid item>
              <Grid container direction={"row"} spacing={6}>
                <Grid item>
                  <LoadingMethod
                    item={configItem}
                    packagingType={packagingType}
                    isDeparture={true}
                    config={watch("loadingType")}
                  />
                </Grid>
                <Grid item>
                  <LoadingMethod
                    item={configItem}
                    packagingType={packagingType}
                    isDeparture={false}
                    config={watch("unloadingType")}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container justifyContent={"space-between"}>
                <Grid item>
                  <Item
                    item={configItem}
                    packagingType={packagingType}
                    configIsInputTotalLength={configIsInputTotalLength}
                  />
                </Grid>
                {watch("vehicleType") !== "오토바이" &&
                  configIsInputTotalLength && (
                    <Grid item>
                      <TotalLength/>
                    </Grid>
                  )}
                {watch("vehicleType") !== "오토바이" && (
                  <Grid item>
                    <TotalWeight/>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <OptionMixedLoading/>
        </Grid>
      </Grid>
    </Fragment>
  );
}
